import { Card, Flex } from "antd";
import Paragraph from "antd/es/typography/Paragraph";
import { useTranslation } from "react-i18next";
import { memberType } from "../../../../types/member";
import { formatNumber } from "../../../../utils/formatNumber";
import React from "react";

type SummaryCardProps = {
  data: memberType;
};
const SummaryCard: React.FC<SummaryCardProps> = ({
  data,
}: SummaryCardProps) => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  if (data.points === null && data.coupons === null && data.credits === null) {
    return;
  }
  return (
    <Card
      styles={{
        body: { padding: 0 },
      }}
      className="shadow-lg rounded-[12px] card-shadow "
      bordered={false}
    >
      <Flex style={{ padding: "16px 0px 16px 0px" }}>
        {data.points !== null && (
          <Flex
            vertical
            justify="center"
            style={{ padding: "0px 16px 0px 16px" }}
            className={`w-full border-lineColor ${data.credits !== null || data.coupons !== null ? "border-r" : ""}`}
          >
            <Paragraph className="h1-bold text-center text-o-title">
              {formatNumber(data.points) || "-"}
            </Paragraph>
            <Paragraph className="text-center note-regular text-o-body font-notoSansTC">
              {t("points")}
            </Paragraph>
          </Flex>
        )}
        {data.coupons !== null && (
          <Flex
            vertical
            justify="center"
            style={{ padding: "0px 16px 0px 16px" }}
            className={`w-full border-lineColor ${data.credits !== null ? "border-r" : ""}`}
          >
            <Paragraph className="h1-bold text-center text-o-title">
              {formatNumber(data.coupons) || "-"}
            </Paragraph>
            <Paragraph className="text-center note-regular text-o-body font-notoSansTC">
              {t("Coupon")}
            </Paragraph>
          </Flex>
        )}
        {data.credits !== null && (
          <Flex
            vertical
            justify="center"
            style={{ padding: "0px 16px 0px 16px" }}
            className="w-full"
          >
            <Paragraph className="h1-bold text-center text-o-title">
              {formatNumber(data.credits) || "-"}
            </Paragraph>
            <Paragraph className="text-center note-regular text-o-body font-notoSansTC">
              {data.enable_custom_credits_name && data.custom_credits_name_mapping && data.custom_credits_name_mapping[language]?.trim()
                ? data.custom_credits_name_mapping[language].trim()
                : t("credits")}
            </Paragraph>
          </Flex>
        )}
      </Flex>
    </Card>
  );
};
export default SummaryCard;
